import React from "react";
import Highcharts from "highcharts";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import HighchartsReact from "highcharts-react-official";
import HighchartsConfig from "./config";

Highcharts.setOptions(HighchartsConfig);
HighchartsAccessibility(Highcharts);

export default class Pie extends React.Component {
  render() {
    let titleFontSize;
    let margin = window.innerWidth < 600 ? 5 : 20;

    if (this.props.margin) margin = this.props.margin;

    if (this.props.titleConfig && this.props.titleConfig.titleFontSize)
      titleFontSize = this.props.titleConfig.titleFontSize;
    else titleFontSize = "28px";

    const config = {
      title: {
        text: this.props.value,
        align: "center",
        verticalAlign: "middle",
        style: {
          color: "#0067a5",
          fontSize: titleFontSize,
          fontFamily: "inherit",
          ...(this.props.titleConfig || {}),
        },
        y:
          this.props.titleConfig && this.props.titleConfig.y
            ? this.props.titleConfig.y
            : 10,
      },
      accessibility: {
        enabled: true,
        description: this.props.titleConfig.title,
      },
      chart: {
        height: this.props.style && this.props.style.height,
        width: this.props.style && this.props.style.width,
        backgroundColor: "rgba(255, 255, 255, 0)",
        type: "pie",
        style: { fontFamily: "inherit" },
        margin: [margin, margin, margin, margin],
      },
      legend: {
        align: "right",
        verticalAlign: "top",
        layout: "vertical",
        floating: "true",
        ...(this.props.legendConfig || {}),
      },
      tooltip: { pointFormat: "{point.y:.0f}", ...this.props.tooltip },
      plotOptions: {
        pie: {
          animation: false,
          cursor: "pointer",
          innerSize: "85%",
          dataLabels: { enabled: false },
          showInLegend: true,
          borderWidth: 0,
        },
      },
      series: [{ name: this.props.name, data: this.props.data }],
    };

    return <HighchartsReact highcharts={Highcharts} options={config} />;
  }
}
